module.exports = __webpack_public_path__ + "img/article.8357469c.jpg";